import React from 'react';
import { FaTruckMoving, FaClock, FaLeaf, FaMapMarkedAlt, FaPhoneAlt } from 'react-icons/fa';

function OvernightDelivery() {
  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[700px]"
        style={{ backgroundImage: "url('images/overnight4.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">Overnight Delivery Service</h1>
          <p className="mt-4 text-lg md:text-2xl">
            Get your urgent parcels delivered by the next morning—safe, reliable, and hassle-free.
          </p>
        </div>
      </div>

      {/* Services Section */}
      <section id="overnight-services" className="py-16 bg-white text-white">
        <div className="px-1 md:px-6">
          <h2 className="text-2xl md:text-4xl font-thin text-center mb-8 text-black">Services</h2>
          <p className="text-black text-center font-thin mb-12 text-lg">
            When timing is critical, trust our Overnight Delivery services to meet your deadlines. Here’s what we offer:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-12">
            {/* Reliable Overnight Delivery */}
            <div className="flex flex-col items-center p-8 bg-gray-800 rounded-lg shadow-xl hover:bg-gray-700 transition-all">
              <FaTruckMoving className="w-16 h-16 text-white mb-4" />
              <h3 className="text-2xl font-thin mb-4">Reliable Overnight Delivery</h3>
              <p className="text-zinc-400 text-center font-thin">
                No matter the size or destination of your package, we guarantee reliable and on-time delivery to ensure peace of mind.
              </p>
            </div>

            {/* Nationwide Coverage */}
            <div className="flex flex-col items-center p-8 bg-gray-800 rounded-lg shadow-xl hover:bg-gray-700 transition-all">
              <FaMapMarkedAlt className="w-16 h-16 text-white mb-4" />
              <h3 className="text-2xl font-thin mb-4">Nationwide Coverage</h3>
              <p className="text-zinc-400 text-center font-thin">
                Our network covers urban and rural areas, ensuring your package gets where it needs to go, no matter the location.
              </p>
            </div>

            {/* Time-Sensitive Handling */}
            <div className="flex flex-col items-center p-8 bg-gray-800 rounded-lg shadow-xl hover:bg-gray-700 transition-all">
              <FaClock className="w-16 h-16 text-white mb-4" />
              <h3 className="text-2xl font-thin mb-4">Time-Sensitive Handling</h3>
              <p className="text-zinc-400 text-center font-thin">
                Every second counts—our team is dedicated to handling your time-sensitive shipments with utmost priority and precision.
              </p>
            </div>

            {/* Environmentally Responsible */}
            <div className="flex flex-col items-center p-8 bg-gray-800 rounded-lg shadow-xl hover:bg-gray-700 transition-all">
              <FaLeaf className="w-16 h-16 text-white mb-4" />
              <h3 className="text-2xl font-thin mb-4">Environmentally Responsible</h3>
              <p className="text-zinc-400 text-center font-thin">
                We care about the environment. Our sustainable logistics practices reduce emissions while maintaining top-notch service.
              </p>
            </div>
          </div>
        </div>
      </section>
{/* Why Choose Us Section */}
<section id="why-choose-us" className="py-16 bg-white text-black flex justify-center items-center">
  <div className="px-6 text-center max-w-3xl">
    <h2 className="text-2xl md:text-4xl font-thin mb-8">Why Choose Us?</h2>
    <ul className="text-black text-left text-lg font-thin">
      <li className="mb-4">• 24/7 customer support for any queries or concerns.</li>
      <li className="mb-4">• Affordable and transparent pricing with no hidden costs.</li>
      <li className="mb-4">• State-of-the-art tracking system for real-time updates.</li>
      <li className="mb-4">• Professional and experienced team to handle shipments with care.</li>
    </ul>
  </div>
</section>


     
    </div>
  );
}

export default OvernightDelivery;
